import { ActivatedRoute } from '@angular/router';
import { HostListener, Component, OnInit, Input, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { AppConfig } from '../../app/config/app.config';
import { User } from '../../app/shared/user.model';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { DistributionUnitBE, DUAdditionalInfoBe, DuData } from './shared/distribution-unit.model';
import { PictureBe } from '../image-library/shared/image-model';
import { ImageCommon } from '../image-library/image-common';
import { IReturnObject, } from '../shared/return-object.model';
import { ErrorTypeEnum, StatusEnum } from '../shared/enums.model';
import { DistributionUnitService } from './distribution-unit.service';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { PackagingMaterialService } from '../packaging-material/packaging-material.service';
import { PackagingCodeService } from '../packaging-code/packaging-code.service';
import { AttributeListBE } from '../shared/attribute-list.model';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { UserHandling } from '../shared/user-handling';
import { PackagingMaterialBE } from '../packaging-material/shared/packaging-material.model';
import { PackagingCodeBe } from '../packaging-code/shared/packaging-code.model';
import { PackagingMaterialListBE } from '../../app/packaging-material/shared/packaging-material.model';
import { ChineseChangeValueService } from '../chinese-change-value.service';


declare var jQuery: any;


// Same as database id from table status
const PRELIMINARY = 1;
const ACTIVE = 5;
const MIN_NAME_LENGTH = 2;


@Component({
  moduleId: module.id,
  selector: 'distribution-unit',
  templateUrl: 'distribution-unit.html',
  providers: [DistributionUnitService, PackagingMaterialService, PackagingCodeService],
  styleUrls: ['distribution-unit.css']
})
export class DistributionUnitComponent implements OnInit, ComponentCanDeactivate {

  @Input() distrUnitIdFromParentCtrl: number;
  @Output() duImageId: Array<number> = [];


  fetchDataFunction: any = (searchParam: string) => { this.loadDistrUnitList(searchParam) };
  selectedDistrUnitId: number = -1;
  labelText = "Distribution Unit";

  // Search DU
  viewDUList: boolean = false;
  searchKeyStrokeDelay = 350;
  distrUnitList: AttributeListBE[];
  distrUnit: DistributionUnitBE;
  searchMaterialText = '';
  selectedMaterial: DUAdditionalInfoBe;
  viewMaterialList = false;
  viewMaterialListSpinner = false;
  materialList: DUAdditionalInfoBe[];
  duAdditional: DUAdditionalInfoBe[];
  issuedate: string;
 // UpdatedDate: string;

  // Calculations
  duData: DuData = new DuData();

  // Confirm dialog box
  confirmDlg: NgbModalRef;
  dialogAction: string;
  dialogBtnType: string;
  dialogAppliesTo = "";
  dialogAppliesToId: number = -1;
  confirmDlgText = "";


  // Image handling
  materialSearchListDelayTimer: any = null;
  searchListDelayTimerDelay = 250;

  // Image
  image1: any;
  imageLibraryEvent: PictureBe;
  addImageDlg: NgbModalRef;
  pictureLabels = '';
  imageSearchResult: PictureBe[] = [];
  selectedImages: Array<number> = [];
  pictureIdS: Array<number> = [];
  deleteImageDlg: NgbModalRef;
  deleteImageInfo: PictureBe;
  DUTitle = '';

  // Button bar
  btnBarHidden = false;
  btnDuplicateVisible = false;
  btnNewVisible = true;
  btnActivateVisible = true;
  btnPreviewVisible = true;
  btnSaveVisible = true;
  btnApproveVisible = false;
  btnHistoryVisible = false;
  btnDeleteVisible = true;

  // input action timer
  pendingAction: any = null;

  // search New Du
  selectedSearchMaterialId = 0;
  materialSearchResult: Array<DUAdditionalInfoBe> = [];

  // Misc
  showSpinner = false;
  typeDelayTimer: any = null;
  currentDlg: NgbModalRef;
  isDirty = false;
  user: UserHandling = new UserHandling();
  newInstructionText: string = null;
  Changethedate: Date;
  ChangetheUser: string;
  UpdatedDate: string;

  constructor(
    private packMaterialService: PackagingMaterialService,
    private distUnitService: DistributionUnitService,
    private pkgCodeService: PackagingCodeService,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private config: AppConfig,
    private errHandler: ErrorHandlerService,
    public ChineseChangeValueService:ChineseChangeValueService) {
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty;
  }


  // ----------------------------------------------------------
  // Life cycle hooks
  // ----------------------------------------------------------
  ngOnInit(): void {
    // First check if we get here from a route containing the id
    // If its not from a route, check if the page is used as a control that passes an id
    // If its neither then abort loading
    let id = +this._route.snapshot.params['duId'];
    if (isNaN(id) || id < 1) {
      if (!isNaN(this.distrUnitIdFromParentCtrl) || id > 0) { 
        id = this.distrUnitIdFromParentCtrl;
      }
      else {
        this.showSpinner = false;
        return;
      }
    }
    this.selectedDistrUnitId = id;
    this.loadIDistrUnit(this.selectedDistrUnitId);
  }

  // ----------------------------------------------------------
  // Service calls and support methods
  // ----------------------------------------------------------
  loadDistrUnitList(searchParam: string) {
    this.distrUnitList = null;
    clearInterval(this.typeDelayTimer);

    this.distUnitService.getDistrUnitList(searchParam)
      .subscribe(returnObject => this.loadDistrUnitListResponse(returnObject));
  }

  loadDistrUnitListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'DistributionUnitComponent.loadDistrUnitListResponse',
        ErrorTypeEnum.Error);
        
    } else {
      this.distrUnitList = <AttributeListBE[]>returnObject.DataList;
    }
  }

  previewDistrUnit() {
    // this.errHandler.emitErrorObject(null);
    // this.info("Preview not implemented yet");
    this.distUnitService.GetPreviewPdfforDU(this.distrUnit.Id,this.distrUnit.Material.MHNo)
    .subscribe(returnObject => this.previewInstructionResponse(returnObject));
   }

   previewInstructionResponse(returnObject: any) {
    window.open(this.config.get('apiUrl') + '/DistributionUnit/GetPreviewPdfforDU/?duID=' + this.distrUnit.Id + '&mhNo=' + this.distrUnit.Material.MHNo , '_blank');
}
 u1Name: User = this.getUserData();
  saveDistrUnit() {
    this.showSpinner = true;
    this.btnBarHidden = true;
   // const uName: User = this.getUserData();
    this.distrUnit.UpdatedIssuer= this.u1Name.UserId
    this.distrUnit.UpdatedDate= new Date();
    // Cant delete the picture in DistrUnit because it will then disappear from screen.
    // Alas, we save the DistrUnit in a temp var and remove the bit stream in PictureImage
    // before sending to server.
    const tempDu: DistributionUnitBE = JSON.parse(JSON.stringify(this.distrUnit));
    tempDu.Pictures.forEach(function (item) {
      item.PictureImage = null;
    });
    const body = JSON.stringify(tempDu);
    debugger;
    this.distUnitService.saveDistributionUnit(tempDu)
      .subscribe(returnObject => this.saveDistrUnitResponse(returnObject));
  }

  saveDistrUnitResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'DistributionUnitComponent.saveDistrUnitResponse',
        ErrorTypeEnum.Warning);
    } else {
      this.distrUnit.StatusId === 1
        ? this.info('The distribution unit was saved successsfully')
        : this.info('The distribution unit is now activated');
      this.isDirty = false;
      this.loadDistrUnitResponse(returnObject);
    }
    this.btnBarHidden = false;
    this.showSpinner = false;
  }

  deleteDistrUnit() {
    this.confirmDlg.close();
    this.showSpinner = true;
    this.btnBarHidden = true;
    this.errHandler.emitErrorObject(null);
    this.distUnitService.deleteDistrUnit(this.selectedDistrUnitId)
      .subscribe(returnObject => this.deleteDistrUnitResponse(returnObject));
  }

  deleteDistrUnitResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'DistributionUnitComponent.deleteDistrUnitResponse',
        returnObject.ErrorType);
    } else {
      if (returnObject.DataList[0].Id === -1) {
        this.info('The distribution unit was deleted');
        this.selectedDistrUnitId = null;
        this.setNewDistrUnitData();
      } else {
        this.selectedDistrUnitId = null;
        this.distrUnit = null;
        this.info('The distribution unit was scrapped');
        this.loadDistrUnitResponse(returnObject);
      }
    }
    this.showSpinner = false;
  }

  loadIDistrUnit(duId: number) {
    this.showSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.selectedDistrUnitId = duId;

    this.distUnitService.getDistrUnit(duId)
      .subscribe(returnObject => this.loadDistrUnitResponse(returnObject));
  }

  loadDistrUnitResponse(returnObject: IReturnObject) {
    this.distrUnit = new DistributionUnitBE;
    if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
      this.errHandler.emitError(returnObject.ErrorMsg,
        'DistributionUnitComponent.loadDistrUnitResponse',
        returnObject.ErrorType);
    } else {
      debugger;
      this.selectedDistrUnitId = returnObject.DataList[0].Id;
    //  this.Changethedate= this.distrUnit.UpdatedDate;
      this.distrUnit = <DistributionUnitBE>returnObject.DataList[0];
      this.viewDUList = false;
      this.setLoadedValues(returnObject);
      this.extractImages();

      if (this.distrUnit.DUMaterial.length < 0) {
        const main = new DUAdditionalInfoBe();
        main.MHNo = this.distrUnit.Material.MHNo;
        main.Description = this.distrUnit.Material.Description;
        main.Id = this.distrUnit.Material.Id;
        main.Weight = this.distrUnit.Material.Weight;
        this.distrUnit.DUMaterial.push(main);
      }
      this.setCalculations();
      this.newInstructionText = null;
    }

    this.showSpinner = false;
    this.viewDUList = false;
    this.isDirty = false;
  }

  createNewdistrUnit(modal: any) {
    if (this.isDirty)
      this.confirmContinueWithoutSave(modal);
    else
      this.setNewDistrUnitData();
  }

  createDuplicatedistrUnit(modal: any) {
    if (this.isDirty) {
      this.confirmContinueWithoutSave(modal);
    } else {
      this.createDuplicate();
    }
  }

  getUserData() {
    const userData = localStorage.getItem('userData');
    return new User().deserialize(userData);
  }

  setNewDistrUnitData() {
    debugger;
    const uName: User = this.getUserData();
    this.showSpinner = true;
    this.distrUnit = new DistributionUnitBE();
    this.distrUnit.IssuerUserId = uName.UserId;
    this.distrUnit.IssuerDepartment = uName.Department;
    this.distrUnit.IssuerEmail=uName.Email;
    this.distrUnit.IssuerName = uName.UserName;
    this.issuedate = "";
    this.isDirty = false;
    this.newInstructionText = 'NEW';
    this.distrUnit.InnerUnitString = null;
    this.distrUnit.OuterUnitString = null;
    this.setCalculations();
    this.showSpinner = false;
    this.distrUnit.UpdatedIssuer = uName.UserId;
    this.UpdatedDate = "";
  }

  createDuplicate() {
    this.distrUnit.Id = -1;
    this.newInstructionText = 'COPY OF' + ' ' + this.distrUnit.Material.MHNo;
    this.setCalculations();
  }


  // ----------------------------------------------------------
  // Images handling
  // ----------------------------------------------------------
  extractImages() {
    this.pictureIdS = [];
    ImageCommon.SetBase64Image(this.distrUnit.Pictures);
    this.distrUnit.Pictures.forEach(x => this.pictureIdS.push(x.Id));
    this.pictureLabels = ImageCommon.setPictureLabels(this.distrUnit.Pictures);
    this.DUTitle = this.distrUnit.Material.MHNo;
    this.duImageId = this.pictureIdS;
  }

  selectImageToDistrUnit(addedImage: any) {
    if (this.selectedImages.indexOf(addedImage.Id) === -1) {
      this.selectedImages.push(addedImage.Id);
      this.imageSearchResult.push(addedImage);
    } else {
      this.selectedImages.splice(this.selectedImages.indexOf(addedImage), 1);
      this.imageSearchResult.splice(this.imageSearchResult.indexOf(addedImage.Id), 1);
    }
  }

  addImageToDistrUnit() {
    // debugger;
    for (let i = 0; i < this.selectedImages.length; i++) {

      if (this.pictureIdS.indexOf(this.selectedImages[i]) === -1) {
        const imageObj = this.imageSearchResult.find(x => x.Id === this.selectedImages[i]);
        this.distrUnit.Pictures.push(imageObj);
      }
    }

    this.refreshPictureIds();
    ImageCommon.setPictureLabels(this.distrUnit.Pictures);
    this.imageSearchResult = [];
    this.closeAddImageDlg();
    this.info('Image\'s added.');
    this.setDirty();
  }

  deleteImageFromDistrUnit(imageId: any) {
    ImageCommon.RemovePic(this.distrUnit.Pictures, imageId);
    this.refreshPictureIds();
    this.pictureLabels = ImageCommon.setPictureLabels(this.distrUnit.Pictures);
    this.info('The picture was removed from the distribution unit.');
    this.closeDeleteImageDlg();
    this.setDirty();
  }

  refreshPictureIds() {
    this.pictureIdS = [];
    this.distrUnit.Pictures.forEach(x => this.pictureIdS.push(x.Id));
  }


  // ----------------------------------------------------------
  // search distribution unit methods
  // ----------------------------------------------------------
  searchMaterialTextChanged() {
    const that = this; // needed to preserve scope reference to this within setinterval function
    this.selectedMaterial = null;
    if (that.searchMaterialText.length >= 2) {
      that.viewMaterialList = true;

      // If this.typeDelayTimer is not nulll then the
      // user typed somthing new within time limit so reset timer
      if (that.typeDelayTimer != null)
        clearInterval(that.typeDelayTimer);

      that.typeDelayTimer = setInterval(function () {
        that.loadMaterialList();
      }, that.searchKeyStrokeDelay);
    }
    else {
      that.viewMaterialList = false;
      clearInterval(this.typeDelayTimer);
    }
  }

  loadSelectedMHList() {
    this.viewMaterialListSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.packMaterialService.searchMaterial(this.distrUnit.Material.MHNo)
      .subscribe(returnObject => this.loadMaterialListResponse(returnObject));
  }

  loadMaterialList() {
    this.viewMaterialListSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.packMaterialService.searchMaterial(this.searchMaterialText)
      .subscribe(returnObject => this.loadMaterialListResponse(returnObject));
  }

  selectMaterial(material: DUAdditionalInfoBe) {
    this.searchMaterialText = material.MHNo + ' ' + material.Description;
    this.selectedMaterial = new DUAdditionalInfoBe;
    this.selectedMaterial.Id = material.Id;
    this.selectedMaterial.Weight = material.Weight;
    this.selectedMaterial.Description = material.Description;
    this.selectedMaterial.MHNo = material.MHNo;
    clearInterval(this.materialSearchListDelayTimer);
  }

  selectSelectedMH(material: AttributeListBE) {
    this.distrUnit.Material.MHNo = material.Description;
    clearInterval(this.materialSearchListDelayTimer);
  }

  removeMaterial(removeMaterialId: number) {
    // Check if the material is the distribution unit material
    if (this.distrUnit.Material.Id === removeMaterialId) {
      this.info('Please remove the main material for the Distribution Unit first');
      return;
    }

    // Check if the material is in Outer or Inner unit. If so remove the code first.
    const OuterIndex = this.distrUnit.OuterUnit.findIndex(x => x.CodeCompositionMHId === removeMaterialId);
    const InnerIndex = this.distrUnit.InnerUnit.findIndex(x => x.CodeCompositionMHId === removeMaterialId);

    if (OuterIndex !== -1 || InnerIndex !== -1) {
      this.info('Remove Outer unit or Inner unit to remove the materials from the list');
      return;
    }

    const inx: number = this.distrUnit.DUMaterial.findIndex(x => x.Id === removeMaterialId);

    this.distrUnit.DUMaterial.splice(inx, 1);
    this.setDirty();
    this.setCalculations();
  }

  loadMaterialListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType !== ErrorTypeEnum.NoError)
      this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingMaterialComponent.loadSupplierListResponse', returnObject.ErrorType);
    else
      this.materialList = Object.assign(returnObject.DataList);

    this.viewMaterialListSpinner = false;
  }

  showSelectedMaterialList() {
    if (this.distrUnit.Material.MHNo.length < 7) {
      clearInterval(this.materialSearchListDelayTimer);
      this.viewMaterialList = true;
    }
  }

  showMaterialSearchList() {
    if (this.searchMaterialText.length >= 2) {
      clearInterval(this.materialSearchListDelayTimer);
      this.viewMaterialList = true;
    }
  }

  startMaterialSearchListWithDelay() {
    const that = this;

    if (!that.viewMaterialList) {
      clearInterval(this.materialSearchListDelayTimer);
      return;
    }

    if (that.materialSearchListDelayTimer != null)
      clearInterval(that.materialSearchListDelayTimer);

    that.materialSearchListDelayTimer = setInterval(function () {
      that.finalizeHideMaterialSearchListWithDelay();
    }, that.searchListDelayTimerDelay);
  }

  finalizeHideMaterialSearchListWithDelay() {
    this.viewMaterialList = false;
    clearInterval(this.materialSearchListDelayTimer);
  }

  hideMaterialSearchListWithDelay() {
    clearInterval(this.materialSearchListDelayTimer);
    this.startMaterialSearchListWithDelay();
  }

  isNewMaterialButtonDisabled() {
    return this.selectedMaterial == null || this.isEditDisabled();
  }

  addMaterial() {
    if (this.distrUnit.DUMaterial.findIndex(x => x.Id === this.selectedMaterial.Id) === -1) {
      const newSelection: DUAdditionalInfoBe = new DUAdditionalInfoBe();
      newSelection.Id = this.selectedMaterial.Id;
      newSelection.Description = this.selectedMaterial.Description;
      newSelection.Weight = this.selectedMaterial.Weight;
      newSelection.MHNo = this.selectedMaterial.MHNo;
      this.distrUnit.DUMaterial.push(newSelection);
    } else {
      this.info('The material is already added to the list.');
    }

    this.searchMaterialText = '';
    this.selectedMaterial = null;
    this.setDirty();
    this.setCalculations();
  }


  // ----------------------------------------------------------
  // Dialog boxes and support methods
  // ----------------------------------------------------------
  openOnSaveValidateDlg(modal: any, text: string) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = 'savefail';
    this.dialogBtnType = 'info';
    this.dialogAppliesTo = 'Distribution Unit';
    this.confirmDlgText = text;
    this.dialogAppliesToId = this.distrUnit.Id;
    this.confirmDlg = this.modalService.open(modal);
  }

  openConfirmDeleteDlg(modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = 'delete';
    this.dialogBtnType = 'danger';
    this.dialogAppliesTo = 'Distribution Unit';
    this.dialogAppliesToId = this.distrUnit.Id;
    this.confirmDlg = this.modalService.open(modal);
  }

  confirmContinueWithoutSave(modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = 'continuewithoutsave';
    this.dialogBtnType = 'warning';
    this.dialogAppliesTo = 'Distribution Unit';
    this.dialogAppliesToId = this.distrUnit.Id;
    this.confirmDlg = this.modalService.open(modal);
  }

  onConfirmDlgNotify(command: ConfirmResult): void {
    if (command.Action === 'delete')
      this.deleteDistrUnit();
    else if (command.Action === 'continuewithoutsave') {
      this.confirmDlg.close();
      this.setNewDistrUnitData();
    }
    else if (command.Action === 'cancel')
      this.confirmDlg.close();
    else if (command.Action === 'deletematerial')
      this.deleteMainDu(command.Id);
    else if (command.Action === 'deletematerialcode')
      this.pendingAction(command.Id);
    else
      this.confirmDlg.close();
  }

  removeOuterCodeFromDu(codeId: number) {
    this.errHandler.emitErrorObject(null);
    this.confirmDlg.close();
    for (const material of this.distrUnit.OuterUnit) {
      const index = this.distrUnit.DUMaterial.findIndex(x => x.Id === material.CodeCompositionMHId);
      this.distrUnit.DUMaterial.splice(index, 1);
    }
    this.distrUnit.OuterUnit = [];
    this.distrUnit.OuterUnitString = null;
    this.distrUnit.OuterUnitQuantity = 0;
    this.setDirty();
  }

  removeInnerCodeFromDu(codeId: number) {
    this.errHandler.emitErrorObject(null);
    this.confirmDlg.close();
    for (const material of this.distrUnit.InnerUnit) {
      const index = this.distrUnit.DUMaterial.findIndex(x => x.MHNo === material.MHNo);
      this.distrUnit.DUMaterial.splice(index, 1);
    }
    this.distrUnit.InnerUnit = [];
    this.distrUnit.InnerUnitString = null;
    this.distrUnit.InnerUnitQuantity = 0;
    this.setDirty();
  }

  deleteMainDu(materialId: number): void {
    this.errHandler.emitErrorObject(null);
    this.confirmDlg.close();
    this.distrUnit.Material = new PackagingMaterialBE();
    this.removeMaterial(materialId);
    this.setDirty();
  }

  addMaterialToInstruction() {
    this.showSpinner = true;
    this.errHandler.emitErrorObject(null);
    this.closeDlg();
    this.materialSearchResult = [];
    this.packMaterialService.getMaterial(this.selectedSearchMaterialId)
      .subscribe(returnObject => this.addMaterialToInstructionResponse(returnObject));
  }

  addMaterialToInstructionResponse(returnObject: IReturnObject): void {
    this.distrUnit.Material = returnObject.DataList[0];
    this.showSpinner = false;
    const main = new DUAdditionalInfoBe();
    main.MHNo = this.distrUnit.Material.MHNo;
    main.Description = this.distrUnit.Material.Description;
    main.Id = this.distrUnit.Material.Id;
    main.Weight = this.distrUnit.Material.Weight;
    this.distrUnit.DUMaterial.push(main);
    this.setDirty();
    this.setCalculations();
  }

  onAddMaterial(modal: any) {
    this.currentDlg = this.modalService.open(modal);
  }

  onSearchMaterialDialogExecute(dialogResult: PackagingMaterialListBE[]) {
    if (dialogResult == null) {
      this.closeDlg();
      return;
    }
    this.selectedSearchMaterialId = dialogResult[0].Id;
    this.addMaterialToInstruction();
  }

  onBtnBarButtonNotify(command: string, confirmDlg: any): void {
    if (command === 'new')
      this.createNewdistrUnit(confirmDlg);

    if (command === 'preview')
      this.previewDistrUnit();
    else if (command === 'save' && this.isContentValid(confirmDlg))
      this.saveDistrUnit();
    else if (command === 'activate' && this.isContentValidForApprove(confirmDlg))
      this.saveDistrUnit();
    else if (command === 'history')
      this.viewHistory();
    else if (command === 'duplicate')
      this.createDuplicatedistrUnit(confirmDlg);
    else if (command === 'delete') {
      this.openConfirmDeleteDlg(confirmDlg);
    }
  }


  viewHistory() {
    this.errHandler.emitErrorObject(null);
    this.info('History not implemented yet');
  }


  // ----------------------------------------------------------
  // DU save and approve validation
  // ----------------------------------------------------------
  isContentValid(modal: any): boolean {
    if (!this.isDirty)
      return false;
    else if (!this.isValidNumericValues()) {
      this.openOnSaveValidateDlg(modal,
        'One or more of the characters in dimension fields are not \nnumeric, please correct before saving');
      return false;
    } else if (!this.isValidMainDu()) {
      this.openOnSaveValidateDlg(modal, 'No Material choosen for this Distribution Unit');
      return false;
    }
    else if (!this.isOuterAndInnerValid()) {
      this.openOnSaveValidateDlg(modal, 'Please add both Outer and Inner Unit with quantities');
      return false;
    }
    else if (this.isMaterialQuantityValid()) {
      this.openOnSaveValidateDlg(modal, 'Material quantity should be greater than zero');
      return false;
    }

    return true;
  }

  isOuterAndInnerValid(): boolean {
    if ((this.distrUnit.InnerUnit.length === 0 && this.distrUnit.OuterUnit.length === 0) || (this.distrUnit.InnerUnit == null && this.distrUnit.OuterUnit == null) && this.distrUnit.InnerUnitQuantity === 0 && this.distrUnit.OuterUnitQuantity === 0) {
      return true;
    }

    else if (this.distrUnit.InnerUnit.length > 0 && this.distrUnit.OuterUnit.length > 0 && this.distrUnit.InnerUnitQuantity > 0 && this.distrUnit.OuterUnitQuantity > 0) {
      return true;
    }

    else if (this.distrUnit.OuterUnit.length > 0 && this.distrUnit.OuterUnitQuantity > 0 && this.distrUnit.InnerUnitString == null && this.distrUnit.InnerUnitQuantity === 0) {
      return true;
    }

    return false;
  }

  isMaterialQuantityValid(): boolean {
    for (const material of this.distrUnit.DUMaterial) {

      if(material.Quantity == 0 )
      {
        return true;
      }
    }
      return false;
  }

  isContentValidForApprove(modal: any): boolean {
    const isValid: boolean = this.isContentValid(modal);
    if (!isValid) {
      if (this.distrUnit.DUMaterial.length > 0 && this.distrUnit.Material.StatusId === StatusEnum.Active) {
        this.distrUnit.StatusId = ACTIVE;
        return true;
      } else {
        this.openOnSaveValidateDlg(modal,
          'The material is not yet Active.\nPlease go to the material page and activate first.');
        return false;
      }
    }

    return isValid;
  }

  isValidMainDu(): boolean {
    if (this.distrUnit.Material.MHNo.length > 0) {
      return true;
    }
    return false;
  }

  isValidNumericValues(): boolean {
    const checkValues = true;
    for (const material of this.distrUnit.DUMaterial) {
      if (isNaN(material.Quantity)) {
        return !checkValues;
      }
    }
    if (isNaN(this.distrUnit.UnitHeight)
      || isNaN(this.distrUnit.UnitWidth)
      || isNaN(this.distrUnit.UnitLength)) {
      return !checkValues;
    }
   
    return checkValues;
  }


  // ----------------------------------------------------------
  // info
  // ----------------------------------------------------------
  info(message: string): void {
    this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
  }


  // ----------------------------------------------------------
  // Image Modals
  // ----------------------------------------------------------
  openAddImageToDU(modal: any) {
    this.addImageDlg = this.modalService.open(modal, { size: 'lg' });
  }

  openDeleteImageFromDU(modal: any, pictureInfo: any) {
    this.deleteImageInfo = pictureInfo;
    this.deleteImageDlg = this.modalService.open(modal, { size: 'sm' });
  }

  closeAddImageDlg() {
    this.imageSearchResult = [];
    this.selectedImages = [];
    this.addImageDlg.close();
  }

  closeDeleteImageDlg() {
    this.deleteImageDlg.close();
  }

  countChange(event: PictureBe) {

    this.imageLibraryEvent = <PictureBe>event;
    this.selectImageToDistrUnit(this.imageLibraryEvent);
  }


  // ----------------------------------------------------------
  // MISC
  // ----------------------------------------------------------
  setDirty() {
    this.isDirty = true;
  }

  closeDlg() {
    this.currentDlg.close();
  }


  // ----------------------------------------------------------
  // Weight and calculation
  // ----------------------------------------------------------
  setCalculations() {
    this.duData.GrossWeight = 0;
    this.duData.NetWeight = 0;
    const mainMaterial = this.distrUnit.Material.MHNo;

    for (const material of this.distrUnit.DUMaterial) {
      this.setGrossWeight(material);
      this.setNetWeight(material, mainMaterial);

    }
    if (this.distrUnit.OuterUnit.length > 0) {
      for (const material of this.distrUnit.OuterUnit) {
        this.setGrossWeightPkgCode(material);
      }
    }
    this.distrUnit.GrossWeight = this.duData.GrossWeight;
    this.distrUnit.NetWeight = this.duData.NetWeight;
    this.calculateVolume();
  }

  setGrossWeight(material: DUAdditionalInfoBe) {
    this.duData.GrossWeight += material.Weight * material.Quantity;
  }

  setNetWeight(material: DUAdditionalInfoBe, mainMH: string) {
    if (material.MHNo === mainMH) {
      this.duData.NetWeight += material.Weight * material.Quantity;
    }
  }

  calculateVolume() {
    this.distrUnit.UnitVolume = parseFloat(((this.distrUnit.UnitHeight / 1000)
      * (this.distrUnit.UnitLength / 1000)
      * (this.distrUnit.UnitWidth / 1000)).toFixed(2));
  }

  setGrossWeightPkgCode(codeMaterial: PackagingCodeBe) {
    this.duData.GrossWeight += codeMaterial.PkgCodeWeight * codeMaterial.CompositionQty;
  }


  // ----------------------------------------------------------
  // GUI behaviour
  // ----------------------------------------------------------
  isActiveDU(): boolean {
    return this.distrUnit.StatusDescription === 'active';
  }

  isSearchHidden() {
    return false;
  }

  setLoadedValues(returnObject: IReturnObject) {
    if (this.distrUnit.IssuerUserId == null || this.distrUnit.IssuerUserId.length < 6) {
      this.distrUnit.IssuerUserId = this.user.UserId;
      this.distrUnit.IssuerName = this.user.UserName;
      this.distrUnit.IssuerEmail=this.user.Email;
      this.distrUnit.IssuerDepartment = this.user.Department;
    }

        // check for issuer approver
        if (returnObject.DataList[0].IssuerUserId !== '' && returnObject.DataList[0].IssuerName === '-' && returnObject.DataList[0].IssuerDepartment === '-'  )
        this.errHandler.emitError('Issuer ' + returnObject.DataList[0].IssuerUserId.toUpperCase() + ' doesnt exists in AD, Kindly raise a issue through Customer support to replace user ' + returnObject.DataList[0].IssuerUserId.toUpperCase() + ' in PackIT.' , '', ErrorTypeEnum.Error);
  }

  isAtLeastOneDu(): boolean {
    return this.distrUnit.Material != null && this.distrUnit.Material.MHNo.length > 0;
  }

  isAtLeastOneOuterUnit(): boolean {
    return this.distrUnit.OuterUnit != null && this.distrUnit.OuterUnit.length > 0;
  }

  isAtLeastOneInnerUnit(): boolean {
    return this.distrUnit.InnerUnit != null && this.distrUnit.InnerUnit.length > 0;
  }



  // ----------------------------------------------------------
  // Actions
  // ----------------------------------------------------------
  onDeleteMaterial(materialId: number, modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = 'deletematerial';
    this.dialogAppliesToId = materialId;
    this.dialogAppliesTo = 'Material';
    this.dialogBtnType = 'danger';
    this.confirmDlg = this.modalService.open(modal, { size: 'sm' });
    this.setDirty();
  }

  addInnerUnit(modal: any) {
    this.pendingAction = this.addInnerUnitCode;
    this.confirmDlg = this.modalService.open(modal, { size: 'lg' });
  }

  addOuterUnit(modal: any) {
    this.pendingAction = this.addOuterUnitCode;
    this.confirmDlg = this.modalService.open(modal, { size: 'lg' });
  }

  addCode(modal: any) {
    this.pendingAction = this.addCodeToMaterialList;
    this.confirmDlg = this.modalService.open(modal, { size: 'lg' });
  }

  addCodeToMaterialList: any = (codeList: Array<PackagingCodeBe>) => {
    this.pendingAction = null;

    for (const item of codeList) {
      if (this.distrUnit.DUMaterial.findIndex(x => x.Id === item.CodeCompositionMHId) === -1) {
        this.distrUnit.DUMaterial.push({
          Id: item.CodeCompositionMHId,
          Description: item.MHDescription,
          MHNo: item.MHNo,
          Quantity: item.CompositionQty,
          Weight: item.PackagingMaterialWeight
        });
      }
    }
  }

  addOuterUnitCode: any = (outerUnitList: Array<PackagingCodeBe>) => {
    this.pendingAction = null;
    /**
     * Logic for adding OuterUnit for DU
     */
    this.distrUnit.OuterUnit = outerUnitList;
    for (const material of this.distrUnit.OuterUnit) {
      if (this.distrUnit.DUMaterial.findIndex(x => x.Id === material.CodeCompositionMHId) === -1) {
        this.distrUnit.DUMaterial.push({
          Id: material.CodeCompositionMHId,
          Description: material.MHDescription,
          MHNo: material.MHNo,
          Quantity: material.CompositionQty,
          Weight: material.PackagingMaterialWeight
        });
      }
      this.distrUnit.OuterUnitString = outerUnitList[0].PkgCode;
    }
  }

  addInnerUnitCode: any = (innerUnitList: Array<PackagingCodeBe>) => {
    this.pendingAction = null;
    /**
     * Check if a Outerunit already exist
     */
    if (this.distrUnit.InnerUnitString != null) {
      return;
    }
    /**
     * Logic for adding InnerUnit for DU
     */
    this.distrUnit.InnerUnit = innerUnitList;
    for (const material of this.distrUnit.InnerUnit) {
      if (this.distrUnit.DUMaterial.findIndex(x => x.Id === material.CodeCompositionId) === -1) {
        this.distrUnit.DUMaterial.push({
          Id: material.CodeCompositionMHId,
          Description: material.MHDescription,
          MHNo: material.MHNo,
          Quantity: material.CompositionQty,
          Weight: material.PackagingMaterialWeight
        });
      }
      this.distrUnit.InnerUnitString = innerUnitList[0].PkgCode;
    }
  }

  removeOuterUnit(codeId: number, modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = 'deletematerialcode';
    this.dialogAppliesToId = codeId;
    this.dialogAppliesTo = 'Code';
    this.dialogBtnType = 'danger';
    this.pendingAction = this.removeOuterCodeFromDu;
    this.confirmDlg = this.modalService.open(modal, { size: 'sm' });
  }

  removeInnerUnit(codeId: number, modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = 'deletematerialcode';
    this.dialogAppliesToId = codeId;
    this.dialogAppliesTo = 'Code';
    this.dialogBtnType = 'danger';
    this.pendingAction = this.removeInnerCodeFromDu;
    this.confirmDlg = this.modalService.open(modal, { size: 'sm' });
  }

  onSearchCodeDialogExecute(pkgCodeId: any) {
    this.confirmDlg.close();
    if (pkgCodeId == null)
      return;

    this.pkgCodeService.getPackingCodeFor(pkgCodeId)
      .subscribe(returnObject => this.selectedCodeResponse(returnObject));
  }

  selectedCodeResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorMsg !== '') {
      this.errHandler.emitError(returnObject.ErrorMsg, 'DistributionUnitComponent.selectedCodeResponse',
        ErrorTypeEnum.Error);
      return;
    }
    this.pendingAction(returnObject.DataList);
    this.setCalculations();
    this.setDirty();
  }


  // ----------------------------------------------------------
  // Access rights
  // ----------------------------------------------------------
  isEditDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.distrUnit != null;

    return !(gotAccess);
  }

  isMainMaterialDisabled() {
    // return !(this.distrUnit.StatusId == PRELIMINARY);

    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.distrUnit != null
      && this.distrUnit.StatusId === PRELIMINARY;

    return !gotAccess;
    // let gotActiveAccess: boolean =
    //     ( this.distrUnit.StatusId == ACTIVE || this.distrUnit.StatusId == StatusEnum.Scrapped );

    // return !( gotPreliminaryAccess || !gotActiveAccess );
  }

  isBtnBarHidden(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsPartSupplierUser
        || this.user.IsPurchaser
        || this.user.IsScaniaUser
        || this.user.IsDeveloper)
      && this.distrUnitIdFromParentCtrl == null;

    return !gotAccess;
  }

  isBtnActivateDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.distrUnit != null
      && this.distrUnit.Id !== -1
      && !this.isDirty
      && this.distrUnit.StatusId !== ACTIVE;

    return !gotAccess;
  }


  isBtnPreviewDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsTestPackager
        || this.user.IsPartSupplierUser
        || this.user.IsPurchaser
        || this.user.IsScaniaUser
        || this.user.IsDeveloper
      )
      && this.distrUnit != null
      && this.distrUnit.Id !== -1;

    return !gotAccess;
}

  isBtnNewDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper);

    return !gotAccess;
  }

  isBtnDuplicateDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.distrUnit != null
      && this.distrUnit.Id !== -1;

    return !gotAccess;
  }

  isBtnSaveDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.isDirty
      && this.distrUnit != null
      && (this.distrUnit.StatusId === PRELIMINARY || this.distrUnit.StatusId === ACTIVE);

    return !gotAccess;
  }

  isBtnDeleteDisabled(): boolean {
    const gotAccess: boolean =
      (this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper)
      && this.distrUnit != null
      && (this.distrUnit.StatusId === PRELIMINARY || this.distrUnit.StatusId === ACTIVE)
      && this.distrUnit.Id !== -1;

    return !gotAccess;
  }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/distribution-unit/distribution-unit.component.ts